export const mockData = {
  hero: {
    title: "Tomorrow's Businesses, Today.",
    subtitle: "A multi-industry conglomerate driving innovation across technology, hospitality, FMCG, construction, finance, and logistics. With a global presence and a commitment to sustainable growth, we build solutions that shape the future of business.",
    cta1: "Explore Vision",
    cta2: "View Financials"
  },
  
  stats: {
    branches: 11,
    industries: 11,
    companies: "23+"
  },
  
  about: {
    title: "Building tomorrow's businesses today",
    description: "AR Holdings is a diversified global group committed to shaping the future of industries through technology, strategy, and sustainable innovation. Headquartered in Mountain View, California, with operations across Asia, Europe, and the Americas, we empower growth by building brands that combine cutting-edge technology with real-world impact.",
    mission: "Our portfolio spans blockchain, AI, hospitality, FMCG, logistics, finance, and construction — united by one vision: tomorrow's businesses, today.",
    timeline: [
      { year: "2018", event: "AR Holdings Founded", description: "Established with a vision to build multi-industry conglomerate" },
      { year: "2020", event: "Global Expansion", description: "Expanded operations to 11 countries across 3 continents" },
      { year: "2022", event: "Blockchain Innovation", description: "Launched Dot Protocol and DPC-20 standard" },
      { year: "2024", event: "AI Integration", description: "Integrated AI across all portfolio companies" },
      { year: "2025", event: "Future Vision", description: "Building the next generation of technology-driven businesses" }
    ]
  },
  
  leadership: [
    {
      name: "Arun Kumar",
      role: "Founder & Chairman",
      initials: "AK",
      bio: "Visionary founder of AR Holdings, whose foresight and entrepreneurial spirit laid the foundation of a multi-industry conglomerate. His legacy of innovation and strategy continues to inspire AR Holdings' culture."
    },
    {
      name: "Robb Duran",
      role: "Chief Business Officer",
      initials: "RD",
      bio: "Brings operational expertise and strategic insight to AR Holdings. With extensive experience leading complex technology and corporate initiatives, he ensures seamless execution across verticals."
    },
    {
      name: "Timothy Burton",
      role: "Veteran Advisor",
      initials: "TB",
      bio: "Seasoned leader with decades of experience in technology, blockchain, and logistics. His expertise strengthens AR Holdings' long-term direction and market leadership."
    },
    {
      name: "Saleena Thamani",
      role: "Group CEO",
      initials: "ST",
      bio: "Pioneering blockchain developer and architect of the DPC-20 token standard. She merges technical excellence with creativity, innovating at the intersection of fintech and blockchain. Also an accomplished fashion designer."
    },
    {
      name: "Rudra Narayanan",
      role: "Head of Business & Strategy",
      initials: "RN",
      bio: "Leads business development, strategic partnerships, and go-to-market execution. With a background in cross-border ventures, he focuses on driving sustainable growth and expanding global footprint."
    }
  ],
  
  industries: [
    {
      category: "Technology",
      icon: "Cpu",
      companies: [
        { name: "Dot Protocol Company Ltd", description: "Blockchain & Token Standards (DPC-20)" },
        { name: "Ask Trabaajo Inc", description: "HR Technology (AI-driven workforce management)" },
        { name: "Tau LLC", description: "Operating System & Consumer Electronics" },
        { name: "Vaycays", description: "Travel & B2B Tourism" }
      ]
    },
    {
      category: "Defence Technology",
      icon: "Shield",
      companies: [
        { name: "The Brain", description: "Advanced defence technology and strategic systems" },
        { name: "The Biis", description: "Defence technology solutions and innovation" }
      ]
    },
    {
      category: "Telecom",
      icon: "Radio",
      companies: [
        { name: "Numbr", description: "Telecommunications and digital connectivity solutions" }
      ]
    },
    {
      category: "FMCG",
      icon: "ShoppingBag",
      companies: [
        { name: "AR Food and Beverages LLC", description: "Chocolates, Coffee, Tea" },
        { name: "AR Distilleries LLC", description: "Wine, Whiskey, Tequila" }
      ]
    },
    {
      category: "Hospitality",
      icon: "Building2",
      companies: [
        { name: "AR Hospitality Co. Ltd", description: "Luxury & Eco Resorts" }
      ]
    },
    {
      category: "Construction",
      icon: "HardHat",
      companies: [
        { name: "AR Constructions & AR Ecocity", description: "Sustainable Living & Construction" },
        { name: "AR Spaces", description: "Interior Design & Smart Spaces" }
      ]
    },
    {
      category: "Fashion & Lifestyle",
      icon: "Sparkles",
      companies: [
        { name: "AR Fashion & Lifestyle", description: "Daily Wear & Accessories" },
        { name: "AR Biolabs Co. Ltd", description: "Cosmetics, Perfumes, Serums" }
      ]
    },
    {
      category: "Logistics",
      icon: "Truck",
      companies: [
        { name: "AR Shipping Co. Ltd", description: "Logistics, Cargo & Global Supply Chain" }
      ]
    },
    {
      category: "Consulting",
      icon: "Briefcase",
      companies: [
        { name: "AR Consulting", description: "Corporate M&A & Business Strategy" },
        { name: "3 Block Collective", description: "Web3 & Blockchain Consulting" }
      ]
    },
    {
      category: "Finance & Banking",
      icon: "Landmark",
      companies: [
        { name: "Global Dot Bank", description: "Digital Banking (Borderless Finance)" },
        { name: "3DOT Merchant Pay", description: "Web3 Merchant Payment Solutions" },
        { name: "3DOT Cards", description: "Web3 Payment Cards" }
      ]
    },
    {
      category: "CSR & Foundations",
      icon: "Heart",
      companies: [
        { name: "Kibouor", description: "Sustainable Living & Outreach Programs" },
        { name: "Tau Foundation", description: "Food NGO supporting communities" }
      ]
    }
  ],
  
  blockchain: {
    title: "The Blockchain Ecosystem",
    subtitle: "Connecting all AR companies under one unified protocol",
    description: "All AR Holdings companies are being integrated into the Dot Protocol blockchain ecosystem, powered by the 3DOT Coin and DPC20 standard. This revolutionary approach creates seamless interoperability across all our businesses.",
    features: [
      {
        title: "Dot Protocol",
        description: "A blockchain infrastructure designed for enterprise-scale operations across multiple industries"
      },
      {
        title: "3DOT Coin",
        description: "The native cryptocurrency powering transactions across the entire AR Holdings ecosystem"
      },
      {
        title: "DPC20 Standard",
        description: "Our proprietary token standard enabling smart contracts and digital asset management"
      }
    ]
  },
  
  vision: {
    title: "We don't follow disruption. We engineer it.",
    statements: [
      {
        heading: "Our Vision",
        text: "To build a future where technology empowers every industry, where blockchain creates transparency, where AI drives innovation, and where sustainable growth is the foundation of every business decision."
      },
      {
        heading: "Our Mission",
        text: "To create world-class companies that leverage cutting-edge technology to solve real-world problems, generate sustainable value, and positively impact communities across the globe."
      },
      {
        heading: "Our Values",
        text: "Innovation without compromise. Technology with purpose. Growth with responsibility. We believe in building businesses that don't just succeed today, but shape the world of tomorrow."
      }
    ]
  },
  
  offices: [
    { country: "United States (HQ)", address: "1075 Terra Bella Ave, Mountain View, CA, 94043" },
    { country: "Dubai, UAE", address: "Level 29, Marina Plaza, Dubai Marina" },
    { country: "Belize", address: "Suite 305, Matalon Building, Coney Drive, Belize City" },
    { country: "Turkey", address: "Maslak Mah., Büyükdere Cad., Istanbul 34398" },
    { country: "India", address: "91 Springboard, MG Road, Bengaluru, 560001" },
    { country: "Thailand (Asia HQ)", address: "23 Sukhumvit Soi 13, Khlong Toei Nuea, Bangkok 10110" },
    { country: "Singapore", address: "20 Collyer Quay, #23-01, Raffles Place, 049319" },
    { country: "Malaysia", address: "Level 36, Menara Citibank, Jalan Ampang, Kuala Lumpur 50450" },
    { country: "Indonesia", address: "World Trade Center 3, Jalan Jenderal Sudirman, Jakarta 12930" },
    { country: "Vietnam", address: "Saigon Trade Center, 37 Ton Duc Thang, District 1, Ho Chi Minh City" },
    { country: "South Korea", address: "23F, Seoul Finance Center, 136 Sejong-daero, Jung-gu, Seoul" }
  ]
};